export default "__VITE_ASSET__26640534__"